import styled from "styled-components";
import { PRIMARY, SECONDARY } from "../../const/colors";
import { mobile_title } from "../../const/fonts";

export const ContainerModal = styled.div`
  background-color: #fff;
	border: 1px solid ${PRIMARY};
  width: 80vw;

   /* h2, div[data-qid='cipSection']:nth-child(2), div#form > div > div > span {
    color: #fff;
  } */
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${PRIMARY};
  position: relative;

  h2 {
    padding: 0.7rem;
    margin: 0 auto;
    color: ${SECONDARY};
    font-weight: 800;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    //justify-content: space-between;
    margin: auto;
    h2 {
      font-size: ${mobile_title};
      padding: 0;
      flex: 1;
      text-align: center;

    }
  }
  @media screen and (max-width: 480px) {
    margin-bottom: 0;
  }
`;

export const ButtonClose = styled.button`
	border: none;
	background-color: #fff;
	color: ${SECONDARY};
	padding: 0.2rem 0.5rem;
	cursor: pointer;
	transition: background-color 0.3s ease-in-out;
  margin-left: auto;
  position: absolute;
  right: 0;
  top: 0;
	svg {
		font-size: 2.5rem;
	}
	&:hover {
		background-color: #93291E;
		svg {
			color: #fff;
		}
	}
  @media screen and (max-width: 768px) {
    position: relative;

    svg {
      font-size: 2rem;
    }
  }
`;